export const defaultFormatPaywallCurrency = {
  includeCurrencyCode: false,
};
